export var CustomerAccessPolicyVoData;
(function (CustomerAccessPolicyVoData) {
    CustomerAccessPolicyVoData["ANONYMOUS_AND_LOGIN"] = "ANONYMOUS_AND_LOGIN";
    CustomerAccessPolicyVoData["LOGIN"] = "LOGIN";
})(CustomerAccessPolicyVoData || (CustomerAccessPolicyVoData = {}));
//# sourceMappingURL=customer-access-policy-vo-data.js.map


//////////////////
// WEBPACK FOOTER
// ../od-ts/dist/vo/customer-apps/customer-access-policy-vo-data.js
// module id = 932
// module chunks = 14